module.exports = __webpack_public_path__ + "static/img/37.7ec776f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/37.jpg
// module id = Tm1z
// module chunks = 1